import { AccessLevel, Route } from 'src/routes/Route'
import { toggleIsNewContactModalOpen } from 'src/redux/actions'
import { GroupsRoute } from './GroupsRoute'

export const RelationshipManagerRoute = Route({
  path: '/relationship-manager',
  accessLevel: AccessLevel.PRIVATE,
  init: (subroute?: GroupsRoute, isNewContactModalOpen: boolean = false) => ({
    subroute,
    isNewContactModalOpen,
  }),
  fromPath: () => ({ isNewContactModalOpen: false }),
  reducer: (state, action) => {
    if (action.type === toggleIsNewContactModalOpen.type) {
      return {
        ...state,
        isNewContactModalOpen: !state.isNewContactModalOpen,
      }
    } else {
      return state
    }
  },
  subroute: GroupsRoute,
})
export type RelationshipManagerRoute = Route<typeof RelationshipManagerRoute>
